import { Collapse } from 'bootstrap';

export function registerAccordionAnchor(): void {
  if (window.location.hash && window.location.hash.length > 1) {
    const collapses = document.querySelectorAll<HTMLElement>(`.accordion-collapse`);
    const target = document.querySelectorAll<HTMLElement>(`.accordion-item[id=${window.location.hash.substring(1)}] .accordion-collapse`)[0];
    const targetAnchorOnly = document.getElementById(`${window.location.hash.substring(1)}`);
    

    // Collapse all except the target panel
    if ((target || targetAnchorOnly ) && collapses.length > 0) {
      collapses.forEach(c => {
        const bsCollapse = Collapse.getOrCreateInstance(c, { toggle: false });

        if (c === target || c.contains(target) || c.contains(targetAnchorOnly)) {
          bsCollapse.show();
        } else {
          bsCollapse.hide();
        }
      });

      // Normal behavior of the anchor link breaks, so we scroll to the target panel
      // Delay for accordion animation to finish

      if (target) {
        setTimeout(function () {
          target.parentElement.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }, 500);
      } else {
        setTimeout(function () {
          targetAnchorOnly.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }, 500);
      }
      
    }
  }
}

// Run on page load
document.addEventListener('DOMContentLoaded', () => {
  registerAccordionAnchor();
});

// Run when hash changes
window.addEventListener('hashchange', () => {
  registerAccordionAnchor();
});
